import api from '@motionelements/core/src/api/base-api-v2';

// eslint-disable-next-line
export const getCoupon = async (id, params) => api.get(`/v2/coupons/${id}`, {
  params,
});

// export const redeemCoupon = async id => api.get(`/v2/coupons/${id}`);
